const normalizeBaseUrl = (value) => String(value || '').trim().replace(/\/+$/, '');

const coerceApiPath = (pathValue) => {
  const path = String(pathValue || '').trim();
  if (!path || path === '/') return '/api';

  const lowerPath = path.toLowerCase();
  const apiIndex = lowerPath.indexOf('/api');
  if (apiIndex >= 0) {
    return path.slice(0, apiIndex + 4);
  }

  return `${path.replace(/\/+$/, '')}/api`;
};

const configuredApiBase = () => (
  normalizeBaseUrl(process.env.REACT_APP_DJANGO_API_BASE)
  || normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL)
);

export const getApiBaseUrl = () => {
  const rawBase = configuredApiBase();

  if (!rawBase) {
    // Local CRA development relies on package.json proxy for /api requests.
    return '/api';
  }

  if (rawBase.startsWith('/')) {
    return coerceApiPath(rawBase);
  }

  try {
    const parsed = new URL(rawBase);
    return `${parsed.origin}${coerceApiPath(parsed.pathname)}`;
  } catch {
    return /\/api$/i.test(rawBase) ? rawBase : `${rawBase}/api`;
  }
};

export const apiUrl = (path) => {
  const normalizedPath = String(path || '').startsWith('/') ? path : `/${path}`;
  return `${getApiBaseUrl()}${normalizedPath}`;
};

export const extractApiErrorMessage = (payload) => {
  if (typeof payload === 'string' && payload.trim()) return payload.trim();
  if (!payload || typeof payload !== 'object') return '';

  const candidates = [
    payload.detail,
    payload.message,
    payload.error,
    payload.error?.message,
    payload.error?.detail,
    payload.error?.code,
  ];

  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) return candidate.trim();
    if (Array.isArray(candidate) && candidate.length) {
      const first = candidate.find((item) => typeof item === 'string' && item.trim());
      if (first) return first.trim();
    }
  }

  return '';
};

export const readFailedApiResponse = async (response, fallback) => {
  const contentType = String(response?.headers?.get('content-type') || '').toLowerCase();
  const fallbackMessage = fallback || 'Unable to generate the official contract PDF.';

  if (contentType.includes('application/json')) {
    try {
      const payload = await response.json();
      return extractApiErrorMessage(payload) || fallbackMessage;
    } catch {
      return fallbackMessage;
    }
  }

  const text = String((await response.text()) || '').trim();
  if (!text) return fallbackMessage;
  if (contentType.includes('text/html') || /^\s*</.test(text)) {
    return (
      `Contract API returned HTML instead of a PDF (HTTP ${response.status}). `
      + 'Verify REACT_APP_DJANGO_API_BASE points to the Django origin, not the booking site.'
    );
  }
  return text;
};
